// The layer editor's failures in live's words, shown where the editor shows its errors (spec
// G13b decision 5: no toasts).

/** A failure whose message is live's own words, shown as it is. */
export class LayerError extends Error {}

/** A failure's words: live's own where it said them, else the action's (live's fallback). */
export function wordsOf(error: unknown, fallback: string): string {
  return error instanceof LayerError ? error.message : fallback;
}

/** What the editor last says: a failure in live's words, or that a save is done. */
export interface Notice {
  words: string;
  tone: "error" | "done";
}

export function problem(words: string): Notice {
  return { words, tone: "error" };
}

export function done(words: string): Notice {
  return { words, tone: "done" };
}
